import { requestDealerDownloadScannedAr } from 'utils/http/api/dealer/loans';
import useModal from 'utils/modal/useModal';

export function useDealerFinancingDetailArInformationLogics(loanId: number) {
  const modal = useModal();

  const onClickDownloadScannedAr = async (e: any) => {
    e.preventDefault();
    try {
      await requestDealerDownloadScannedAr(loanId);
    } catch (e) {
      modal.show(e);
    }
  };

  return {
    onClickDownloadScannedAr,
  };
}
